var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { CountryConfiguration } from "./../models/V1/VATNumberValidationConfiguration/CountryConfiguration";
export class VATNumberValidationConfiguration {
  /**
   * Creates an instance of VATNumberValidationConfiguration.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof VATNumberValidationConfiguration
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetAllRq_ _getAllRq
   * @returns Promise<GetAllRq_>
   * @memberof VATNumberValidationConfiguration
   */
  getAll(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/VATNumberValidationConfiguration", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: CountryConfiguration, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateRq_ _updateRq
   * @returns Promise<UpdateRq_>
   * @memberof VATNumberValidationConfiguration
   */
  update(pUpdateRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/VATNumberValidationConfiguration/{countryCode}", "PATCH", "application/json; charset=UTF-8", "application/json; charset=UTF-8", options);
    client.addPathParams([{ name: "countryCode", value: pUpdateRq.countryCode, required: true }]);
    client.addBody({ value: pUpdateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
